import { useTranslation } from "react-i18next";

export default function Unauthorized() {
  const { t } = useTranslation("common");
  return (
    <div className="p-8 text-center">
      <h2 className="text-xl font-semibold">{t("accessDenied.title")}</h2>
      <p className="opacity-70 mt-2">
        {t("accessDenied.description")}
      </p>
    </div>
  );
}